import { NgModule } from '@angular/core';
import { ChatUiModule } from '../chat-ui.module';
import { ChatPreferencesDialogComponent } from './chat-preferences-dialog.component';

/**
 * Internal Chat notification preferences (SPEC-2026-07-internal-chat, T-21 ·
 * RF-36) — quiet hours + sound. Declaration-only module (the gate service is
 * `providedIn: 'root'`), so being reachable from an eager AND a lazy module is
 * harmless. Imported by ChatStatusModule because the status picker opens this
 * dialog.
 */
@NgModule({
  imports: [ChatUiModule],
  declarations: [ChatPreferencesDialogComponent],
  exports: [ChatPreferencesDialogComponent],
})
export class ChatPreferencesModule { }
